(function () {
  'use strict';

  angular
    .module('app.translate', []);
})();
